import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, FileInput, FormField, Grid, List, Select, Text, TextArea, TextInput, Image } from "grommet";
import { debounce, sum } from "lodash";
import * as React from "react";
import Avatar from "react-avatar";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";

import NavigateToPath from "../components/NavigateToPath";
import BadgeLogoPicker from "./BadgeLogoPicker";

import { newBadgeIcon } from "./BadgesManagement";
import { BadgeViewModel, CreateBadge } from "./BadgeStore";
import BadgeDetails from "./BadgeDetails";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const xmark = <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>;

const FileReaderAsync = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            resolve(reader.result as string);
        };
        reader.onerror = reject;

        reader.readAsDataURL(file);
    });
};

const BadgeCreate = ({ onCreated }: { onCreated: Function }) => {
    const [name, setName] = React.useState("");
    const [description, setDescription] = React.useState("");

    const [logoUri, setLogoUri] = React.useState("");

    const [isParticipationBadge, setIsParticipationBadge] = React.useState(false);

    const [logoContent, setLogoContent] = React.useState("");

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    const navigate = useNavigate();

    let create = () => {
        setError("");
        setIsCreating(true);
        CreateBadge({ description, name, logoUri, logoContent, isParticipationBadge }).then(
            (result) => {
                onCreated();
                setIsCreating(false);
            },
            (error) => {
                setError(error);
            }
        );
    };

    const handleLogoChange = ({ uri, content }) => {
        if (content) {
            setLogoContent(content);
            setLogoUri("");
        } else if (uri) {
            setLogoUri(uri);
            setLogoContent("");
        }
    };

    return (
        <div>
            <Box direction="row">
                <h1>Create Badge </h1>
                <NavigateToPath path="/badge/create"></NavigateToPath>
            </Box>
            <Box width={{ max: "400px" }} pad="small" round="5px" gap="small">
                <BadgeDetails
                    badge={{ name, description, logoURI: logoUri, isParticipationBadge } as BadgeViewModel}
                    isBusy={isCreating}
                    onChange={({ name, description, logoUri, logoContent }) => {
                        setName(name);
                        setDescription(description);
                        setLogoUri(logoUri);
                        setLogoContent(logoContent);
                    }}
                ></BadgeDetails>
                <Box direction="row">
                    <CustomButton loading={isCreating} primary icon={newBadgeIcon} onClick={create} disabled={isCreating || !name} label="Create"></CustomButton>
                </Box>
                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default BadgeCreate;
